import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ReactModal from 'react-modal';
import classNames from 'classnames';
import Spinner from '../LazyWidgets/Spinner';
import MLIcon from '../MLIcon';
import MLButton from '../MLButton';
import MLDialogTitle from './MLDialogTitle/MLDialogTitle';
import MLDialogActions from './MLDialogActions/MLDialogActions';

import s from './MLDialog.module.css';

if (import.meta.env.MODE !== 'test') {
  ReactModal.setAppElement('#container');
}

class MLDialog extends Component {
  static defaultProps = {
    onActionsSubmit: null,
    titleClassName: '',
    className: '',
    bodyClassName: '',
    actionsClassName: '',
    closeButtonClassName: '',
    isRequired: false,
    disableEnforceFocus: false,
  };

  static propTypes = {
    app: PropTypes.object,
    onClose: PropTypes.func,
    show: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    actions: PropTypes.array,
    footerErrors: PropTypes.array,
    onActionsSubmit: PropTypes.func,
    titleClassName: PropTypes.string,
    titleTextClassName: PropTypes.string,
    closeButtonClassName: PropTypes.string,
    className: PropTypes.string,
    bodyClassName: PropTypes.string,
    overlayClassName: PropTypes.string,
    actionsClassName: PropTypes.string,
    isRequired: PropTypes.bool,
    testId: PropTypes.string,
    closeTestId: PropTypes.string,
    hideActionsBorder: PropTypes.bool,
    disableEnforceFocus: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    const { onActionsSubmit } = this.props;
    let keydownListener = null;
    if (onActionsSubmit) {
      keydownListener = this.handleKeyDown.bind(this);
      document.addEventListener('keydown', keydownListener);
    }
    this.state = {
      keydownListener,
    };
  }

  componentWillUnmount() {
    const { keydownListener } = this.state;
    if (keydownListener) {
      document.removeEventListener('keydown', keydownListener);
    }
  }

  handleKeyDown(e) {
    if (e.keyCode === 13) {
      this.props.onActionsSubmit();
    }
  }

  render() {
    const {
      show,
      onClose,
      children,
      actions,
      title,
      titleClassName,
      titleTextClassName,
      className,
      bodyClassName,
      actionsClassName,
      closeButtonClassName,
      isRequired,
      footerErrors,
      testId,
      closeTestId,
      overlayClassName,
      app,
      hideActionsBorder,
      disableEnforceFocus,
    } = this.props;
    const isLoading = get(app, 'loading', false);
    let actionClasses = `${s.dialogActions} ${s.dialogActionsBorder} ${actionsClassName}`;
    if (hideActionsBorder) {
      actionClasses = `${s.dialogActions} ${actionsClassName}`;
    }
    return (
      <ReactModal
        className={`${s.dialog} ${className}`}
        overlayClassName={classNames(s.dialogOverlay, overlayClassName)}
        bodyOpenClassName={s.__dialogOpen}
        isOpen={show}
        onRequestClose={onClose}
        role="dialog"
        aria={{
          labelledby: '__mlDialog_title',
          modal: 'true',
        }}
        shouldCloseOnOverlayClick={!isRequired}
        data={{ 'test-id': testId }}
        shouldFocusAfterRender={!disableEnforceFocus}
      >
        <div
          className={
            title === ''
              ? s.dialogNoTitle
              : `${s.dialogTitle} ${titleClassName}`
          }
        >
          <MLDialogTitle
            title={title}
            titleTextClassName={titleTextClassName}
          />
          {!isRequired && (
            <MLButton
              className={`${s.closeBtn} ${closeButtonClassName}`}
              onClick={onClose}
              ariaLabel="close"
              testId={closeTestId}
            >
              <MLIcon className={s.closeIcon} type="x" title="Close" />
            </MLButton>
          )}
        </div>
        {isLoading && <Spinner className={s.loading} />}
        <div
          className={`${s.dialogBody} ${bodyClassName} ${
            isLoading && s.opacity
          }`}
        >
          {children}
        </div>
        <MLDialogActions
          actions={actions}
          footerErrors={footerErrors}
          actionClasses={actionClasses}
        />
      </ReactModal>
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

export default connect(mapStateToProps)(MLDialog);
